import { motion } from 'framer-motion';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  light?: boolean;
}

export default function SectionTitle({ title, subtitle, light }: SectionTitleProps) {
  return (
    <motion.div
      className="text-center mb-10 md:mb-14"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.6 }}
    >
      {subtitle && (
        <span
          className={`inline-block uppercase tracking-widest text-sm font-semibold mb-3 ${
            light ? 'text-white/80' : 'text-coffee-400'
          }`}
        >
          {subtitle}
        </span>
      )}
      <h2
        className={`font-display text-3xl md:text-4xl lg:text-5xl leading-tight ${
          light ? 'text-white' : 'text-coffee-900'
        }`}
      >
        {title}
      </h2>
      <div className="mx-auto mt-4 h-1 w-16 rounded-full bg-gradient-to-r from-coffee-400 to-terracotta-400" />
    </motion.div>
  );
}
